/* iSpice collection pages - 2026-10-06
   Small, safe enhancements on top of ispice-collection.css. If anything here fails, the
   page still shows every product with its full title and working Add to cart.
   - splits long titles ("iSpice | Name | 4.62 oz | Halal | Kosher") into name, size and tags
   - "Save NN%" badge from the sale price
   - short intro with "Read more", certification chips, product count
   - a friendly message on empty collections */
(function () {
  'use strict';
  var TAGS = ['Organic', 'Salt Free', 'Salt-Free', 'Sugar Free', 'Sugar-Free', 'Halal', 'Kosher', 'Vegan', 'Gluten Free', 'Gluten-Free', 'Non-GMO', 'Keto', 'MSG Free'];
  var SIZE = /\b\d+(?:\.\d+)?\s?(?:oz|ounce|ounces|lb|lbs|g|gr|kg|ml|pack|pk|ct|count)\b/i;

  function norm(t) { return t.replace(/\s+/g, ' ').trim(); }
  function price(el) { var m = el && el.textContent.replace(/,/g, '').match(/\d+(?:\.\d+)?/); return m ? parseFloat(m[0]) : 0; }

  function splitTitle(a) {
    if (!a || a.dataset.icDone) return;
    a.dataset.icDone = '1';
    var full = norm(a.textContent);
    var parts = full.split('|').map(norm).filter(Boolean);
    if (parts.length < 2) return;
    if (/^(ispice( blend)?|szeged|spice)$/i.test(parts[0])) parts.shift(); // brand words in front of the real name
    if (!parts.length) return;
    var name = parts.shift(), size = '', tags = [], seen = {};
    parts.forEach(function (p) {
      if (!size && SIZE.test(p)) { size = p.match(SIZE)[0]; return; }
      TAGS.forEach(function (t) {
        var key = t.toLowerCase().replace('-', ' ');
        if (!seen[key] && new RegExp('\\b' + t.replace('-', '[- ]') + '\\b', 'i').test(p)) { seen[key] = 1; tags.push(t.replace('-', ' ')); }
      });
    });
    if (!size && SIZE.test(name)) size = name.match(SIZE)[0];
    name = name.replace(/\s*[–—-]\s*\d+(?:\.\d+)?\s?(?:oz|ounces?|lbs?|g|gr|kg|ml)$/i, ''); // "Sweet Paprika – 10 oz"
    a.setAttribute('title', full);
    a.setAttribute('aria-label', full);
    a.textContent = name;
    var after = a;
    if (size) {
      var m = document.createElement('div'); m.className = 'ic-meta'; m.textContent = size;
      after.insertAdjacentElement('afterend', m); after = m;
    }
    if (tags.length) {
      var t = document.createElement('div'); t.className = 'ic-tags';
      tags.slice(0, 3).forEach(function (x) { var s = document.createElement('span'); s.textContent = x; t.appendChild(s); });
      after.insertAdjacentElement('afterend', t);
    }
  }

  function saveBadge(card) {
    if (card.querySelector('.ic-save')) return;
    var now = card.querySelector('.product-thumbnail__price > .money');
    var was = card.querySelector('.product-thumbnail__was-price .money');
    var a = price(now), b = price(was);
    if (!a || !b || b <= a) return;
    var pct = Math.round((1 - a / b) * 100);
    if (pct < 5) return;
    var s = document.createElement('span'); s.className = 'ic-save'; s.textContent = 'Save ' + pct + '%';
    var wrap = card.querySelector('.product-image__wrapper');
    if (wrap) wrap.appendChild(s);
  }

  function intro(section) {
    var d = section.querySelector('.collection__description');
    if (!d || d.dataset.icDone) return;
    d.dataset.icDone = '1';
    // drop empty paragraphs/divs (the theme editor leaves <p><br></p> spacers)
    Array.prototype.slice.call(d.children).forEach(function (el) { if (!norm(el.textContent) && !el.querySelector('img,iframe,video')) el.remove(); });
    // a line like "No Preservatives, No artificial colors, ..., Kosher Certified" becomes chips
    Array.prototype.slice.call(d.querySelectorAll('p')).forEach(function (p) {
      var txt = norm(p.textContent);
      var items = txt.split(',').map(norm).filter(Boolean);
      if (items.length >= 4 && items.every(function (x) { return x.length < 40; })) {
        var ul = document.createElement('ul'); ul.className = 'ic-certs';
        items.forEach(function (x) { var li = document.createElement('li'); li.textContent = x; ul.appendChild(li); });
        p.replaceWith(ul);
        d.insertAdjacentElement('afterend', ul);
      }
    });
    if (d.scrollHeight > 130) {
      d.classList.add('ic-clamp');
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'ic-more'; btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = d.classList.toggle('ic-clamp') === false;
        btn.textContent = open ? 'Show less' : 'Read more';
        btn.setAttribute('aria-expanded', String(open));
      });
      d.insertAdjacentElement('afterend', btn);
    }
  }

  function header(section) {
    var h = section.querySelector('h1.collection__title');
    if (h && !section.querySelector('.ic-eyebrow')) {
      var e = document.createElement('span'); e.className = 'ic-eyebrow'; e.textContent = 'iSpice collection';
      h.insertAdjacentElement('beforebegin', e);
    }
    var n = section.querySelectorAll('.collection-matrix .product-wrap').length;
    var paged = section.querySelector('.container--pagination a');
    if (h && n && !paged && !section.querySelector('.ic-count')) {
      var c = document.createElement('span'); c.className = 'ic-count'; c.textContent = n + (n === 1 ? ' product' : ' products');
      h.insertAdjacentElement('afterend', c);
    }
  }

  function empty(section) {
    if (section.querySelector('.product-wrap') || section.querySelector('.ic-empty')) return;
    var host = section.querySelector('.collection-matrix') || section.querySelector('.collection__main');
    if (!host) return;
    var box = document.createElement('div'); box.className = 'ic-empty';
    box.innerHTML = '<h2>Fresh batch coming soon</h2><p>We are restocking this collection. In the meantime, explore our other seasonings - all made fresh in the USA.</p>' +
      '<div class="ic-btns"><a href="/collections/all">Shop all seasonings</a><a href="/collections/top-seller-collection">Best sellers</a></div>';
    Array.prototype.slice.call(host.childNodes).forEach(function (n) { if (n.nodeType === 3 || (n.nodeType === 1 && /no products/i.test(n.textContent))) n.remove(); });
    host.appendChild(box);
  }

  function run() {
    var sections = document.querySelectorAll('.shopify-section.collection-main');
    Array.prototype.forEach.call(sections, function (sec) {
      try { header(sec); } catch (e) { console.warn('ispice-collection header', e); }
      try { intro(sec); } catch (e) { console.warn('ispice-collection intro', e); }
      try { empty(sec); } catch (e) { console.warn('ispice-collection empty', e); }
      Array.prototype.forEach.call(sec.querySelectorAll('.product-wrap'), function (card) {
        try { splitTitle(card.querySelector('.product-thumbnail__title')); saveBadge(card); } catch (e) { console.warn('ispice-collection card', e); }
      });
    });
  }

  function start() {
    run();
    // the theme re-renders the grid when sorting or paging; enhance the new cards too
    var sec = document.querySelector('.shopify-section.collection-main');
    if (sec && 'MutationObserver' in window) {
      var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 60); }).observe(sec, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
